import { z } from "zod";

/*
 * Zod 4 compiles object schemas with `new Function` when it can, and probes for
 * that by calling Function("") on first parse. The site's CSP has no
 * 'unsafe-eval', so the probe is blocked: parsing still works (Zod falls back
 * to its interpreter), but every page that validates logs a CSP violation.
 * jitless skips the probe and the compiler entirely. Import this module before
 * any schema runs in the browser (contact form, AI advisor).
 */
z.config({ jitless: true });
